;(function () {
  'use strict'

  angular
    .module('contrast.google-analytics')
    .factory('GoogleAnalyticsService', GoogleAnalyticsService)

  function GoogleAnalyticsService() {
    'ngInject'

    var service = {
      sendPageView: sendPageView,
      sendException: sendException,
      sendEvent: sendEvent
    }

    return service

    /**
     * Sends a pageview type event to Google Analytics
     * @param page Object with 'originalPath' field as the url path and 'segment' field as the name of the page
     */
    function sendPageView(page) {
      /* eslint-disable no-undef */
      global.CONTRAST.Analytics.sendPageView({
        page: page.originalPath,
        title: page.segment
      })
      /* eslint-enable */
    }

    /**
     * Sends exception message to Google Analytics
     * @param exceptionMessage A description of the exception
     * @param isFatal <code>true<code> if the exception was fatal (redirects to an error page)
     */
    function sendException(exceptionMessage, isFatal) {
      /* eslint-disable no-undef */
      global.CONTRAST.Analytics.sendException({
        exDescription: exceptionMessage,
        exFatal: isFatal
      })
      /* eslint-enable */
    }

    /**
     * Sends an event to Google Analytics
     * @param event
     */
    function sendEvent(event) {
      /* eslint-disable no-undef */
      global.CONTRAST.Analytics.sendEvent({
        eventCategory: event.category,
        eventAction: event.action,
        eventLabel: event.label
      })
      /* eslint-enable */
    }
  }
})()
